<template>
  <div class="order-detail-tab order-detail-tab--overtime">
    <template v-if="!orderId">
      <a-empty description="暂无订单数据" />
    </template>
    <template v-else-if="loading">
      <a-spin tip="加载中..." />
    </template>
    <template v-else-if="!hasData">
      <a-empty description="暂无加班申请记录" />
    </template>
    <div v-else class="tab-content">
      <a-table
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :scroll="{ y: 360 }"
        row-key="id"
      >
        <template slot="startTime" slot-scope="val">
          {{ formatDateTime(val) }}
        </template>
        <template slot="endTime" slot-scope="val">
          {{ formatDateTime(val) }}
        </template>
        <template slot="money" slot-scope="val">
          ￥{{ formatMoney(val) }}
        </template>
        <template slot="status" slot-scope="val">
          {{ statusText(val) }}
        </template>
        <template slot="createTime" slot-scope="val">
          {{ formatDateTime(val) }}
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
import { getOrderOvertimeRecords } from '@/api/order/order'

const STATUS_MAP = {
  PENDING: '待审核',
  APPROVED: '已通过',
  REJECTED: '已拒绝'
}

export default {
  name: 'OvertimeRecord',
  props: {
    orderId: { type: [Number, String], default: null }
  },
  data () {
    return {
      hasData: false,
      loading: false,
      list: [],
      columns: [
        { title: '申请用户', dataIndex: 'userNickname', key: 'userNickname', width: 120, ellipsis: true },
        { title: '申请时间', dataIndex: 'createTime', key: 'createTime', width: 170, scopedSlots: { customRender: 'createTime' } },
        { title: '开始时间', dataIndex: 'startTime', key: 'startTime', width: 170, scopedSlots: { customRender: 'startTime' } },
        { title: '结束时间', dataIndex: 'endTime', key: 'endTime', width: 170, scopedSlots: { customRender: 'endTime' } },
        { title: '金额', dataIndex: 'money', key: 'money', width: 110, scopedSlots: { customRender: 'money' } },
        { title: '状态', dataIndex: 'status', key: 'status', width: 90, scopedSlots: { customRender: 'status' } },
        { title: '备注', dataIndex: 'remark', key: 'remark', ellipsis: true }
      ]
    }
  },
  watch: {
    orderId: {
      immediate: true,
      handler (id) {
        if (id) this.fetchList()
        else {
          this.list = []
          this.hasData = false
        }
      }
    }
  },
  methods: {
    async fetchList () {
      if (!this.orderId) return
      this.loading = true
      this.hasData = false
      try {
        const res = await getOrderOvertimeRecords(this.orderId)
        const data = (res && res.data) ? res.data : []
        this.list = Array.isArray(data) ? data : []
        this.hasData = this.list.length > 0
      } catch (e) {
        this.list = []
        this.hasData = false
      } finally {
        this.loading = false
      }
    },
    statusText (val) {
      return STATUS_MAP[val] != null ? STATUS_MAP[val] : (val != null ? String(val) : '-')
    },
    formatMoney (value) {
      const amount = Number(value)
      return Number.isNaN(amount) ? '0.00' : amount.toFixed(2)
    },
    formatDateTime (val) {
      if (!val) return '-'
      const d = new Date(val)
      if (isNaN(d.getTime())) return val
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const h = String(d.getHours()).padStart(2, '0')
      const min = String(d.getMinutes()).padStart(2, '0')
      const s = String(d.getSeconds()).padStart(2, '0')
      return `${y}-${m}-${day} ${h}:${min}:${s}`
    }
  }
}
</script>

<style lang="less" scoped>
.order-detail-tab {
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.order-detail-tab .tab-content {
  width: 100%;
  padding: 16px;
  align-self: flex-start;
}
</style>
